module.exports = __webpack_public_path__ + "img/41.59ddce67.png";